import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { CartDrawer } from './CartDrawer';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-172">
      <Header data-id="element-173" />
      <main className="flex-grow" data-id="element-174">
        <Outlet data-id="element-175" />
      </main>
      <Footer data-id="element-176" />
      <CartDrawer data-id="element-177" />
    </div>;
}